<div class="container-fluid background-transparent pt-0">
  <app-trial-license-warning></app-trial-license-warning>
  <lib-campaigns></lib-campaigns>
</div>

<div class="content-inner background-section">
  <div class="title-bar background-transparent" *ngIf='isDesktop'>
    <a class="back-button mt-2 mb-4" (click)="emitData({key:'back'})"><img class="svg mr-2 ml-4 back-button"
        src="assets/ph-bhp-layout/svg/back.svg" /> {{ translationKeys.SOPObservation.Back | translate}}</a>
    <div class="container-fluid d-md-flex justify-content-between background-transparent">
      <h2 class="page-title">{{ 'SOP_MANAGEMENT.COMMENTS' | translate }}</h2>
      <div>
        <lib-php-bhp-chart-export (childData)="emitData($event)" [exportComponent]="compliance" [results]="results"
          [filters]="filters ? filters.toArray() : []" [sopId]="sopIDs" [chart]="chart" [kendoPDF]="compliance.pdf"
          [gridData]="gridData" [fields]="fields" [secGridData]="gridDataComments" [secFields]="fieldComments"
          [select]="'comments'" [fileName]="pageTitle" [appName]="appName" class="col p-0"
          [clickImageBtn]="clickImageBtn" [clickExcelBtn]="clickExcelBtn" [clickPdfBtn]="clickPdfBtn"
          [userData]="userData" [gridDataComments]="gridDataComments" [fieldsComments]="fieldComments"
          (resetClickBtn)="resetExportAs($event)"></lib-php-bhp-chart-export>
      </div>
    </div>
  </div>
  <div class="evaluation-section container-fluid reportFiter">
    <div class="row">
      <div class="col my-3 d-flex  justify-content-end">
        <button class="btn-link-reset" (click)="resetFilters()" *ngIf=isDesktop>{{ 'EVALUATION.RESET_FILTERS' |
          translate }}</button>
      </div>
    </div>

    <div>
      <div class="row">
        <div class="col-md-7 col-sm-12">
          <div class="form-group multiselect-container">
            <div class="multiselect-top d-flex justify-content-between">
              <label>{{ "EVALUATION.SOP" | translate }}</label>
              <button class="multiselect-clear" (click)="resetSOPFilter(true)">
                <img src="assets/icons/closeOutlined.svg" />
              </button>
            </div>
            <div class="multiselect-div">
              <kendo-multiselect #multiselect [data]="sopDetail" [(ngModel)]="sopIDs" [textField]="'title'" (valueChange)="onMultiselectChange($event)"
                [valueField]="'sopid'" [autoClose]="false" placeholder="{{ 'EVALUATION.All.SOPS' | translate }}">
                <ng-template kendoMultiSelectTagTemplate let-dataItem>
                  {{ getSOPTranslation(dataItem.title) | labelSanitizer}}
                </ng-template>
                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                  <input type="checkbox" class="k-checkbox">
                  <div>
                    <span>{{ getSOPTranslation(dataItem.title) | labelSanitizer }}</span>
                    <br />
                    <small class="text-muted institution-names">
                      {{ evaluationService.getInstitutionNames(dataItem, roleId) | labelSanitizer }}
                    </small>
                   </div>
                </ng-template>
              </kendo-multiselect>
            </div>
          </div>
        </div>
        <div class="col-md-5 col-sm-12">
          <div class="form-group">
            <div class="dropdown dropdown-bhp">
              <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                <input class="dropdown-toggle" type="text" [ngModel]="selectedCommentName | translate | labelSanitizer"
                  readonly />
                <span class="label-dropdown">{{ 'SOP_MANAGEMENT.COMMENTS' | translate }}</span>
                <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
              </div>
              <ul class="dropdown-menu">
                <li value="0" class="dropdown-item" (click)="onCommentChange(0)"> {{ 'EVALUATION.All.COMMENTS' |
                  translate }}</li>
                <li class="dropdown-item" *ngFor="let comment of quickComments" [Value]="comment"
                  (click)="onCommentChange(comment)">{{comment.commentName | translate | labelSanitizer}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

    </div>
    <ng-container *ngFor="let filterIndex of filterIndices; let i = index; trackBy: trackLoop">
      <lib-ph-bhp-filter #filter [filterIndex]="i" [userData]="userData" [isDesktop]='isDesktop'
        [shouldShowRemoveButton]="filterIndex > 0" (filterRemoved)="onFilterRemoved(filterIndex)"
        [userHasFilter]="userHasFilter" (filterSaved)="onFilterSaved()" *ngIf="filterIndex === 0 || (filterIndex > 0 )">
      </lib-ph-bhp-filter>
    </ng-container>

    <div class="row">
      <div class="col my-3 justify-content-end d-flex">
        <button *ngIf="isDesktop && filterIndices.length < 6" class="btn-cancel-bordered-bd"
          (click)="filterCompare()">{{ 'EVALUATION.ADD_FILTER' | translate }}</button>
      </div>
    </div>

    <div class="row">
      <div class="col my-3 d-flex  justify-content-end">
        <!-- <button class="btn-link" (click)="saveSummarisedReport()" *ngIf=isDesktop
          [ngClass]="!userHasFilter ? 'disabled-summarised' : ''">{{ 'EVALUATION.SAVE_SUMMARISED_REPORT' |
          translate }}</button> -->

        <div class="dropdown dropdown-bhp-export">
          <div class="dropdown-container-input" [ngClass]="!userHasFilter ? 'disabled' : ''" data-toggle="dropdown"
            aria-expanded="false">
            <div class="d-flex align-items-center">
              <img class="dropdown-arrow mr-2"
                src="{{ !userHasFilter ? 'assets/icons/downloadDarkOutlined-disabled.svg' : 'assets/icons/downloadDarkOutlined.svg' }}" />
              <label [ngClass]="!userHasFilter ? 'disabled-export' : ''">{{ 'EVALUATION.EXPORT' | translate }}</label>
            </div>
            <img class="dropdown-arrow"
              src="{{ !userHasFilter ? 'assets/icons/arrowDropdownOutlined-disabled.svg' : 'assets/icons/arrowDropdownOutlined.svg' }}" />
          </div>

          <ul class="dropdown-menu">
            <li class="dropdown-item" *ngIf="compliance.pdf" (click)="exportAs()">{{ 'EVALUATION.IMAGE' | translate }}
            </li>
            <li class="dropdown-item" *ngIf="results" (click)="excelDownload()">{{ 'GENERAL.EXCEL' | translate }}</li>
            <li class="dropdown-item" *ngIf="compliance.pdf" (click)="downloadKendoPDF()">{{ 'EVALUATION.PDF_DOCUMENT' |
              translate }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div *ngIf="userHasFilter">
      <div class="row mb-4">
        <h1 class="section-title col-md-6 pl-4">{{ 'SOP_MANAGEMENT.COMMENTS' | translate }}</h1>
        <div [ngClass]="!noDataFound ? 'active-refresh' : 'inactive-refresh'"
          class="justify-content-end col-md-6 refresh-box" (click)="onRefreshClick(noDataFound)">
          <img *ngIf="!noDataFound" src="assets/ph-bhp-evaluation/icon-refresh-active.svg" />
          <img *ngIf="noDataFound" src="assets/ph-bhp-evaluation/icon-refresh-inactive.svg" />
          <span>{{ 'CONFIGURE.FILTERS.REFRESH' | translate }}</span>
        </div>
      </div>
      <ng-container *ngFor="let result of results; let i = index">
        <div class="col-12 chartContainer">
          <lib-ph-bhp-bar-chart #chart [isAdjustableHeight]="isAdjustableHeight" [isDesktop]='isDesktop'
            *ngIf="userHasFilter" (onSeriesClick)="onSeriesClick($event)" [majorUnit]="25"></lib-ph-bhp-bar-chart>
        </div>
        <!-- <div class="no-data-box" *ngIf="result.noDataFound && userHasFilter">
          <div class="no-data-filters justify-content-start d-flex">
            <div class="no-data-title" *ngFor="let dataSet of result?.resultChart?.chartOptions.series || []; let j = index;">
              <div class="filter-box"
                  [ngClass]="'filter-box-'+dataSet.filterNum">
              </div>
              <span class="filter-box-text">{{ dataSet.filterName}}</span>
            </div>
          </div>
          <div class="no-data-message">
            <div class="d-flex justify-content-end" *ngIf="!result.noDataFound && userHasFilter">
              <p class="sub-steps-legend">{{ 'EVALUATION.RELEVANT_LEGEND' | translate }}</p>
            </div>
            <div class="no-data-textDiv" *ngIf="result.noDataFound && userHasFilter">
              <span class="no-data-text">{{ 'CONFIGURE.FILTERS.NO_DATA_FOUND' | translate }}</span>
            </div>
            <div class="no-data-textDiv" *ngIf="result.noDataFound && !userHasFilter">
              <span class="no-data-text">{{ 'CONFIGURE.FILTERS.NO_FILTER_FOUND' | translate }}</span>
            </div>
          </div>
        </div> -->
        <div class="col-12 gridContainer" *ngIf="userHasFilter" [ngClass]="{'bottomFreeText':false}"><!-- result.gridDataFreeText}">-->
          <bd-light-table [gridData]="result.gridData || []" [pageInfo]="pageInfo" [fields]="result.fields"
            [isEvaluationTable]="isEvaluationTable" [chartType]="'filter'" [NAifEmpty]="true" [multiSelectText]="multiSelectText"></bd-light-table>
        </div>
        <!-- FreeTextTable Disabled -->
        <!-- <div class="col-12 gridContainer" *ngIf="userHasFilter">
          <bd-light-table [gridData]="result.gridDataFreeText || [] " [pageInfo]="pageInfo" [fields]="result.fieldsFreeText"
            [isEvaluationTable]="isEvaluationTable" [chartType]="'filter'" [multiSelectText]="multiSelectText"></bd-light-table>
        </div> -->
      </ng-container>
  </div>
</div>
<lib-ph-bhp-pdf-compliance-multi-filter #compliance
  [class.isMobile]='!isDesktop'></lib-ph-bhp-pdf-compliance-multi-filter>
